export const DATE_FORMATS = [
    'JULIAN',
    'DDMMYY',
    'DDMMYYYY',
    'DMYY',
    'YY',
    'YYYY',
    'YYMMDD',
    'YYYYMMDD',
    'YYYYMM',
    'YYMM',
    'YYMD',
    'MDYY',
    'DD-MM-YY',
    'DD-MM-YYYY',
    'D-M-YY',
    'YY-MM-DD',
    'YYYY-MM-DD',
    'YYYY-MM',
    'YY-MM',
    'YY-M-D',
    'M-D-YY',
    'DD/MM/YY',
    'DD/MM/YYYY',
    'D/M/YY',
    'YY/MM/DD',
    'YYYY/MM/DD',
    'YYYY/MM',
    'YY/MM',
    'YY/M/D',
    'M/D/YY',
] as const;

export type DateFormat = typeof DATE_FORMATS[number];

/**
 * Return the year token (a run of `Y`s) found in a moment.js format string, or null if none.
 * `Y` is the only uppercase-Y moment token and the custom-format input forbids escaped
 * literals (`[ ]`), so a run of `Y`s is unambiguously the year portion of a typed format.
 *   'YYYY-MM-DD' -> 'YYYY'   'DD/MM/YYYY' -> 'YYYY'   'YY' -> 'YY'   'MMDD' -> null
 *
 * Only the first run of `Y`s is returned. A format with two separate Y-groups (e.g.
 * `YY-YYYY`) would yield the shorter leading group, but no predefined DATE_FORMATS entry
 * has this shape and it is extremely unlikely from custom input — and even then
 * buildMomentYearPattern still produces a functionally correct (if broader) year pattern,
 * so the case is intentionally left as-is.
 */
export function findYearToken(format: string): string | null {
    const match = format?.match(/Y+/);
    return match ? match[0] : null;
}
